import { CountryCode } from "../redux/slices/geoLocation";
import store, { CoreReduxState } from "../redux/store";

export const isEn = (state = store.getState()) => {
  const { language } = state;
  return language === "en";
};

export const isDeLanguage = (state = store.getState()) => {
  const { language } = state;
  return language === "de";
};

export const isEsLanguage = (state = store.getState()) => {
  const { language } = state;
  return language === "es";
};

export const isUS = (state = store.getState()) => {
  const { geoLocation } = state;
  return geoLocation.country_code === "US";
};

export const isCA = (state = store.getState()) => {
  const { geoLocation } = state;
  return geoLocation.country_code === "CA";
};

export const isUK = (state = store.getState()) => {
  const { geoLocation } = state;
  return geoLocation.country_code === "UK" || geoLocation.country_code === "GB";
};

export const isEU = (state = store.getState()) => {
  const { geoLocation } = state;
  return geoLocation.is_eu_citizen;
};

export const isEnUS = (state = store.getState()) => {
  return isUS(state) && isEn(state);
};

export const isEnIntl = (state = store.getState()) => {
  return !isUS(state) && isEn(state);
};

export const isCountry = (
  countries: CountryCode[],
  state = store.getState()
) => {
  const { geoLocation } = state;
  return countries.includes(geoLocation.country_code);
};

/**
 * Feet and pounds
 */
export const isCountryImperial = (state?: CoreReduxState) => {
  return isCountry(["US", "CA"], state);
};

/**
 * Kilos or stones and meters
 */
export const isCountryStones = (state?: CoreReduxState) => {
  return isUK(state) || isCountry(["IE"], state);
};

/**
 * Kilos and meters
 */
export const isCountryMetric = (state?: CoreReduxState) => {
  return !isCountryImperial(state) && !isCountryStones(state);
};
